/*
 * SPDX-FileCopyrightText: 2023 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// eslint-disable-next-line @stencil-community/ban-exported-const-enums
var UploadFileState;
(function (UploadFileState) {
    UploadFileState["SELECT_FILE"] = "SELECT_FILE";
    UploadFileState["LOADING"] = "LOADING";
    UploadFileState["UPLOAD_FAILED"] = "UPLOAD_FAILED";
    UploadFileState["UPLOAD_SUCCESSED"] = "UPLOAD_SUCCESSED";
})(UploadFileState || (UploadFileState = {}));

export { UploadFileState as U };

//# sourceMappingURL=upload-file-state-de676cd5.js.map